import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SubscriptionPlan } from '@vi-iot/client';

import { UIService } from '@services';
import {
  ActiveErrorsStore,
  BookingStore,
  InstallationDetailsStore,
  RemoteDiagnosticsService,
} from '@store';

import { PaidFeaturesEnum } from '../../../../../shared/pipes/paid-feature-available/paid-feature-available.pipe';
import { ActiveErrorDetailsSections } from '../guided-troubleshooting.model';

@Component({
  selector: 'app-active-error-blur',
  templateUrl: './active-error-blur.component.html',
  styleUrls: ['./active-error-blur.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveErrorBlurComponent {
  readonly activeErrorDetailsSections = ActiveErrorDetailsSections;
  readonly subscriptionPlan = SubscriptionPlan;
  readonly GTS = PaidFeaturesEnum.GuidedTroubleshooting;

  mockedFreezeFrame = new Array(13);
  mockedVddMobile = new Array(7);
  mockedVddDesktop = new Array(4);

  @Input() header: string;
  @Input() isHeaderInside = true;
  @Input() isFreezeFrameErrorOccurred: boolean;
  @Input() isLiveVddErrorOccurred: boolean;
  @Input() section: ActiveErrorDetailsSections;
  @Input() isStartDiagnosticsSessionButton: boolean;

  constructor(
    public activeErrorsStore: ActiveErrorsStore,
    public uiService: UIService,
    public installationDetailsStore: InstallationDetailsStore,
    public bookingStore: BookingStore,
    private remoteDiagnosticsService: RemoteDiagnosticsService
  ) {}

  scrollToTop(): void {
    this.remoteDiagnosticsService.scrollToTop();
  }
}
